<section class="container-fluid">
  <div class="row">
    <div class="col-12" #filtersContainer>
      <form class="container-style mb-2" [formGroup]="formInvoicingReportFilter">
        <div class="row">
          <div class="d-flex justify-content-between mb-1 headers-container">
            <div class="filter-name"><b>Filtros</b></div>
            <div class="d-flex align-items-end gap-1">
              <app-custom-button *ngIf="changeFilters" [title]="'Exportar'" [severity]="'success'"
                [icon]="'pi pi-file-excel'" (onClick)="exportExcel()"></app-custom-button>
              <app-custom-button *ngIf="changeFilters" [title]="'Imprimir'" [severity]="'primary'"
                [icon]="'pi pi-print'" (onClick)="printReport()"></app-custom-button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col filter-date">
            <app-custom-datepicker formControlName="initialDate" [labelText]="'Desde'" [recovery]="true"
              [required]="true" (onChangeDate)="changeFilter()"></app-custom-datepicker>
          </div>
          <div class="col filter-date">
            <app-custom-datepicker formControlName="finalDate" [labelText]="'Hasta'" [recovery]="true" [required]="true"
              (onChangeDate)="changeFilter()"></app-custom-datepicker>
          </div>
          <div class="col filters">
            <app-custom-autocomplete formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranch"
              (onChangeSelect)="changeBranch($event)"></app-custom-autocomplete>
          </div>
          <div class="col filters">
            <app-custom-autocomplete formControlName="enterpriseId" [labelText]="'Empresa'" [list]="filteredEnterprise"
              (onChangeSelect)="changeEnterprise($event)"></app-custom-autocomplete>
          </div>
          <div class="col filters">
            <app-custom-autocomplete formControlName="conceptInvoicingId" [labelText]="'Concepto'" [list]="listConcept"
              (onChangeSelect)="changeConceptInvoicing($event)"></app-custom-autocomplete>
          </div>
          <div class="col field-buttons d-flex flex-row align-items-end gap-1">
            <app-custom-button [title]="'Recuperar'" [label]="'Recuperar'" [severity]="'primary'" [variant]="undefined"
              (onClick)="send()"></app-custom-button>
            <app-custom-button [title]="'Limpiar'" [severity]="'secondary'" [icon]="'pi pi-eraser'"
              (onClick)="clear()"></app-custom-button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="custom-table-container" [hidden]="!changeFilters">
    <app-custom-table-report *ngIf="changeFilters" [dataReport]="dataReport"
      [filtersHeight]="filtersHeight"></app-custom-table-report>
  </div>
</section>